var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.clientStatus === 'LOGGED-OUT')?_c('LoginForm',{on:{"login":_vm.refreshLoginState}}):(_vm.clientStatus === 'READY')?_c('MainApp',{on:{"logout":_vm.refreshLoginState}}):_vm._e(),_c('vue-snotify')],1)}
var staticRenderFns = []

export { render, staticRenderFns }